class DealerAddresses {

    constructor(addresses, headQuarter, types = []) {
        this.types = types
        this.addresses = addresses
        this.headQuarter = headQuarter
        this.filteredAddresses = addresses

        this.sortAddressIndex()
    }

    reset() {
        this.setCurrent(this.addresses)
    }

    setTypes(types) {
        this.types = types
    }

    get() {
        return this.addresses;
    }

    set(addresses) {
        this.addresses = addresses;
    }

    getCurrent() {
        return this.filteredAddresses;
    }

    setCurrent(addresses) {
        this.filteredAddresses = addresses;
    }

    setHeadQuarter(address) {
        this.headQuarter = address;
    }

    getHeadQuarter() {
        return this.headQuarter;
    }

    /**
     *
     * @returns {{latitude: *|number, longitude: *|number}}
     */
    getHeadQuarterCoordinates() {
        let hq = this.getHeadQuarter()[0];
        return {latitude: hq.latitude, longitude: hq.longitude}
    }

    /**
     * combine Addresses and HQ
     *
     * @returns {T[] | string}
     */
    join() {
        return this.getHeadQuarter().concat(this.getCurrent())
    }

    /**
     * Filter by Country
     *
     * @param {String} country
     * @param {DealerGeolocator} provider
     */
    filterByCountry(country, provider) {
        let filteredAddresses = provider.filterByCountry(this.getCurrent(), country);
        this.setCurrent(filteredAddresses);
    }

    /**
     * Filter by types (Supercars, Tuning, Boats)
     */
    filterByTypes() {
        if (this.types.length <= 0) {
            this.setCurrent([])
            return;
        }

        let addresses = this.getCurrent().filter(address => {
            for (let i = 0; i < this.types.length; i++) {
                if (address[this.types[i]] === true) return true
            }

            return false
        })

        this.setCurrent(addresses)
    }

    /**
     *
     * @param {{latitude: number, longitude: number}} center
     * @param {DealerGeolocator} provider
     */
    sortByDistance(center, provider) {
        let sortedAddresses = provider.sortByDistance(this.getCurrent(), center);
        this.setCurrent(sortedAddresses);
    }

    /**
     * Sort by HQ
     * isHQ 1|0|null
     */
    sortByHeadquarter() {

        this.setCurrent(
            this.getCurrent().sort((a, b) => (a.isHQ === b.isHQ) ? 0 : a.isHQ ? -1 : 1)
        );
    }

    /**
     * Sort by Position
     * position int|null
     */
    sortByPosition() {

        this.setCurrent(
            this.getCurrent().sort((a, b) => a.position - b.position)
        );
    }

    /**
     * sort Address Index
     *
     * @returns {Array}
     */
    sortAddressIndex() {
        let sorted = [];

        this.getCurrent().forEach((address, index) => {
            address.address_index = index;
            sorted.push(address);
        });

        this.setCurrent(sorted)
    }

    /**
     * find address by identifier
     * @param identifier
     * @returns {*}
     */
    findByIdentifier(identifier) {
        return this.get().filter((address) => {
            return (address.identifier === identifier);
        })
    }

    /**
     * convert address into google.maps.LatLng
     *
     * @param {{latitude: number, longitude: number}} address
     * @returns {google.maps.LatLng}
     */
    static toLatLng(address) {
        return new google.maps.LatLng(address.latitude, address.longitude);
    }
}

export default DealerAddresses;
